import { type RefObject, useLayoutEffect, useRef, useState } from "react";

/**
 * The element's width from just before `hold` turned on, kept while it stays
 * on; `undefined` otherwise. A busy button uses it so swapping its content for
 * a spinner and a label never changes its width.
 *
 * Spec: specs/design-system/ledger-primitives.feature
 */
export function useHeldWidth({
  hold,
  ref,
}: {
  hold: boolean;
  ref: RefObject<HTMLElement | null>;
}): number | undefined {
  const lastWidth = useRef<number | undefined>(undefined);
  const [held, setHeld] = useState<number | undefined>(undefined);

  useLayoutEffect(() => {
    if (!hold) {
      lastWidth.current = ref.current?.getBoundingClientRect().width;
      setHeld(undefined);
      return;
    }
    if (lastWidth.current) setHeld(lastWidth.current);
  }, [hold, ref]);

  return hold ? held : undefined;
}
